function SkeletonBlock({className = ''}: {className?: string}) {
  return (
    <div
      className={['skeleton-shimmer rounded', className].join(' ')}
      aria-hidden
    />
  )
}

export default function KegCollectionFormSkeleton() {
  return (
    <div
      aria-busy="true"
      aria-live="polite"
      aria-label="Loading collection form"
    >
      <span className="sr-only">Loading venue collection form…</span>

      <div className="flex flex-col items-center gap-2 break-words text-center">
        <SkeletonBlock className="h-4 w-40" />
        <SkeletonBlock className="h-3.5 w-52" />
        <SkeletonBlock className="h-3.5 w-56" />
        <SkeletonBlock className="mt-1 h-3 w-36" />
      </div>

      <div className="px-7 py-9">
        {/* Keg quantity inputs */}
        <div className="mb-5">
          <div className="flex flex-col items-center gap-3">
            {Array.from({length: 4}).map((_, index) => (
              <div
                className="flex items-center justify-center gap-3"
                key={`qty-${index}`}
              >
                <SkeletonBlock className="h-4 w-10" />
                <SkeletonBlock className="h-10 w-24" />
              </div>
            ))}
          </div>
        </div>

        {/* Available collection days */}
        <div className="mb-5">
          <SkeletonBlock className="mb-1 h-3 w-44" />
          <SkeletonBlock className="mb-2 h-3 w-64 max-w-full" />
          <div className="my-2 flex gap-2">
            {Array.from({length: 5}).map((_, index) => (
              <SkeletonBlock
                className="h-10 w-1/5"
                key={`day-${index}`}
              />
            ))}
          </div>
          <SkeletonBlock className="mt-2 h-8 w-full" />
        </div>

        {/* Collection times slider */}
        <div className="mb-5">
          <SkeletonBlock className="mb-1 h-3 w-48" />
          <SkeletonBlock className="mb-2 h-3 w-56 max-w-full" />
          <div className="mt-[23px] flex h-[25px] items-center">
            <SkeletonBlock className="h-2 w-full rounded-full" />
          </div>
          <SkeletonBlock className="mt-2 h-6 w-full" />
        </div>

        {/* Keg location cards */}
        <div className="mb-5">
          <SkeletonBlock className="mb-2 h-3 w-24" />
          <div className="flex gap-2">
            {Array.from({length: 3}).map((_, index) => (
              <SkeletonBlock
                className="h-16 w-1/3"
                key={`location-${index}`}
              />
            ))}
          </div>
          <SkeletonBlock className="mt-2 h-6 w-full" />
        </div>

        {/* Contact phone */}
        <div className="mb-5">
          <SkeletonBlock className="mb-2 h-3 w-28" />
          <SkeletonBlock className="h-11 w-full" />
        </div>

        {/* Pickup instructions */}
        <div className="mb-5">
          <SkeletonBlock className="mb-2 h-3 w-44" />
          <SkeletonBlock className="h-[100px] w-full" />
          <div className="mt-1 flex justify-end">
            <SkeletonBlock className="h-3 w-12" />
          </div>
        </div>

        {/* Submit button */}
        <SkeletonBlock className="h-10 w-full rounded" />
      </div>
    </div>
  )
}
